import toasts, { Preset } from '../models/toasts';

export const defaultHeaders: HeadersInit = {
  'mt-app-name': 'my-account'
};

export async function fetchWrapper(
  url: string,
  options: RequestInit = {}
): Promise<Response> {
  options.headers = {
    ...defaultHeaders,
    ...options.headers
  };

  try {
    return await fetch(url, options);
  } catch (error) {
    toasts.addCode({
      code: 'NetworkError',
      preset: Preset.Danger
    });
    throw error;
  }
}
